import { DatePipe } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { CardFooterBaseComponent, ImmomioIconName } from '@resident-nx/shared';
import { interval } from 'rxjs';
import { LabelWebComponent } from '../../atoms/label/label.component';
import { IconWebComponent } from '@resident-nx/web/ui';

@Component({
  standalone: true,
  selector: 'rs-web-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconWebComponent, LabelWebComponent],
})
export class CardFooterWebComponent extends CardFooterBaseComponent implements OnInit {
  #destroyRef = inject(DestroyRef);
  @Input() publishedAt: string | null;
  public immomioIconName = ImmomioIconName;
  public displayText = '';

  constructor(
    protected override translate: TranslateService,
    protected override datePipe: DatePipe
  ) {
    super(translate, datePipe);
  }

  ngOnInit(): void {
    this.displayText = this.setTimeAgo(this.publishedAt);
    interval(60000)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(() => (this.displayText = this.setTimeAgo(this.publishedAt)));
  }
}
